import gql from 'graphql-tag';

// Comments plan 3c: a thread's status and assignee; edit right sets both, the assignee only moves the status.
export default gql`
mutation setCommentState($commentId: Int!, $status: String!, $assigneeId: Int) {
  insert_page_comment_states_one(
    object: {comment_id: $commentId, status: $status, assignee_id: $assigneeId},
    on_conflict: {constraint: page_comment_states_pkey, update_columns: [status, assignee_id]}
  ) {
    comment_id
  }
}
`;
